import { toNDigits } from 'lib/bytes';

export const getSize = (size: number): string => toNDigits(size, 3).value;
export const getSizeInteger = (size) => {
    if (Number.isInteger(size)) {
        return size;
    }

    return size ? size.original : 0;
};
